export const VALIDADOR_LIQUIDACIONES_MODULE_ID = 'validador_liquidaciones'
export const RECURSOS_HUMANOS_CATEGORY_ID = 'recursos_humanos'

export { defaultConfiguracionEquipoAccess as defaultValidadorLiquidacionesAccess } from './configuracionEquipoModule'

